;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { RemovableBadge } from '@qogita/ui/v2/removable-badge'
import { useInventoryQueryParams } from 'src/deprecated/hooks/utils/useInventoryQueryParams'

const useActiveFilters = () => {
  const { toggleBrandsFilter, brandsFilter } = useInventoryQueryParams()

  return brandsFilter.map((brand) => ({
    key: brand,
    label: brand,
    onRemove: () => toggleBrandsFilter(brand),
  }))
}

export const ActiveFiltersBadges = () => {
  const filters = useActiveFilters()

  if (!filters.length) return null

  return (
    <ul className="mt-4 flex flex-wrap gap-2" aria-label="Active filters">
      {filters.map(({ key, label, onRemove }) => (
        <li key={key}>
          <RemovableBadge emphasis="high" onRemove={onRemove} shape="square">
            {label}
          </RemovableBadge>
        </li>
      ))}
    </ul>
  )
}
